import { apiRequest } from "./apiClient";

/* =========================
   SEND OTP
========================= */

export const sendParentOtp = async ({ mobileNo, applicationId }) => {
  return apiRequest("sendParentOtp", "POST", {
    mobileNo,
    applicationId,
  });
};

/* =========================
   CONTECT US
========================= */

export const contactUs = async (formData) => {
  return apiRequest("contactUs", "POST", formData);
};

/* =========================
   VERIFY OTP
========================= */

export const verifyParentOtp = async ({
  mobileNo,
  applicationId,
  password,
  deviceToken,
}) => {
  return apiRequest("verifyParentOtp", "POST", {
    mobileNo,
    applicationId,
    password,
    deviceToken,
  });
};

/* =========================
   VERIFY TOKEN
========================= */

export const verifyTokenApi = async (token) => {
  return apiRequest("verifyToken", "POST", { token });
};


/* =========================
   CREATE ORDER
========================= */

export const createOrder = async (amount, token) => {
  return apiRequest("createOrder", "POST", amount, token);
};


/* =========================
   VERIFY PAYMENT
========================= */

export const verifyPayment = async (data, token) => {
  return apiRequest("verifyPayment", "POST", data, token);
};

/* =========================
   SCHEDULE DOWNGRADE PLAN
========================= */

export const scheduleDowngradePlan = async (data, token) => {
  return apiRequest("scheduleDowngradePlan", "POST", data, token);
};

/* =========================
   CREATE SUBSCRIPTION
========================= */

export const createSubscription = async (data, token) => {
  return apiRequest("createSubscription", "POST", data, token);
}

/* =========================
   VERIFY SUBSCRIPTION
========================= */

export const verifySubscription = async (token) => {
  return apiRequest("verifySubscription", "GET", null, token);
};